<script>
    import ImageTile from "./ImageTile.svelte";
    import ProductInformation from "./ProductInformation.svelte";
    import EnergyEfficiency from "./EnergyEfficiency.svelte";
    import clickTracker from "../tracking/clickTracker.js";
    import DiscountTag from "./DiscountTag.svelte";
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        recommendation,
        lazyLoad,
        featuresState = {},
        cinemaTracking,
        featureIndex,
        cinemaIndex,
        cinemaMeta,
        additionalCinemaClickTracking,
        hasElevationLevel,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
        personalisedUser = false,
    } = $props();

    const { width: widthAmount } = getContext(cinemaTileDimensionCtxKey);

    const width = `${widthAmount}px`;

    const {
        brandName,
        image,
        _embedded: { "o:variation": variation },
        formattedPrice: pricing,
        tracking,
    } = recommendation;

    const showEnergyEfficiency =
        Array.isArray(variation.energyEfficiencyClasses) && variation.energyEfficiencyClasses.length >= 1;
    const discountValue = featuresState.ENABLE_DISCOUNT_TAG_IN_RECOMMENDATION ? variation.discountValue : null;

    const baseDetailViewUrl = variation._links["o:base-detail-view-url"]?.href;
    const variationDetailViewUrl = variation._links["o:variation-detail-view-url"]?.href;
    const useNewEECLabel = Boolean(featuresState.ENABLE_NEW_EEC_COMPONENT);

    const clickHandler = () => {
        clickTracker(
            cinemaTracking,
            tracking,
            featureIndex,
            cinemaIndex,
            additionalCinemaClickTracking,
            recommendation.additionalClickTracking,
            cinemaMeta,
            recommendation.meta,
            additionalTrackingLabels,
            additionalNextPiTrackingLabels
        );
    };

    const getDataTracking = () => {
        const promoSource = recommendation.tracking?.labels?.promo_Source;
        const promoTypeSuffix = recommendation.tracking?.name?.split("-")[0];

        if (!promoSource || !promoTypeSuffix) {
            return undefined;
        }

        return '{"promo_Source":"' + promoSource + '","promo_Type":"' + `promo_${promoTypeSuffix}` + '"}';
    };
</script>

<div
    style:min-width={width}
    style:max-width={width}
    data-tracking={getDataTracking()}
    data-tracking-feature-id={tracking?.id}
    data-qa="slidingCinemaPromotion"
    class="reco_brand_cinema__tile"
>
    <div class="reco_brand_cinema__tile_content {hasElevationLevel ? 'reco_brand_cinema__tile_content_stacked' : ''}">
        <oc-link-v2 base64-href={btoa(variationDetailViewUrl)}>
            <a class="reco_brand_cinema__adslink" href={baseDetailViewUrl} onclick={clickHandler}>
                <ImageTile variationId={variation.id} {image} {lazyLoad} {featuresState} {personalisedUser} />
                <div class="reco_brand_cinema__product-information">
                    <ProductInformation {brandName} {variation} {pricing} showTopInfo={false} />
                </div>
            </a>
        </oc-link-v2>

        <div class="reco_brand_cinema__discount_tag">
            <DiscountTag {discountValue} />
        </div>
        {#if showEnergyEfficiency}
            <div class="reco_brand_cinema__energy-efficiency">
                <EnergyEfficiency
                    {useNewEECLabel}
                    energyEfficiencyClasses={variation.energyEfficiencyClasses}
                    isBrand={true}
                />
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .reco_brand_cinema {
        &__tile {
            display: flex;
            flex-direction: column;
            margin: 0 8px 0 0;
            vertical-align: top;
            white-space: normal;
            position: relative;
            height: 100%;

            &:last-child {
                margin-right: 0;
            }

            &_content {
                padding: 4px;
                flex-grow: 1;
                background-color: white;
                border-radius: var(--oc-semantic-border-radius-200);

                &_stacked {
                    background-color: var(--background-color, var(--oc-semantic-color-stacked-background, #f0f0f0));
                    filter: var(--oc-semantic-shadow-stacked, unset);
                }
            }
        }

        &__product-information {
            padding: 0 4px;
        }

        &__energy-efficiency {
            padding: 4px 0 8px 4px;
        }

        &__adslink {
            color: black;
            text-decoration: none;
            overflow-y: auto;
        }

        &__adslink:hover {
            text-decoration: black underline;
        }

        &__adslink:hover :global(.reco_cinema__price-per-unit) {
            text-decoration: grey underline;
        }

        &__discount_tag {
            padding: 0 4px;
        }
    }
</style>
